const HEALTH_CHECK = '/healthcheck';
const EXAMPLE = '/example';
const CATALOGS = '';
const CANDIDATE_FORM = '/candidate_form';
const CONSUL_DIRECTORY = '/consul';

export { HEALTH_CHECK, EXAMPLE, CATALOGS, CANDIDATE_FORM, CONSUL_DIRECTORY };
